import { Container, Row, Col, Card } from 'react-bootstrap';

export function ParkGuardFAQPage() {
    return (
        <Container className="py-4">
            <div className="p-3 mb-4 bg-body-tertiary rounded-3 border border-primary">
                <Container fluid className="py-3">
                    <h1 className="display-5 fw-bold">Park Guard FAQ</h1>
                    <p className="col-md-8 fs-4">Frequently Asked Questions about our parking protection plans</p>
                </Container>
            </div>

            <Row className="g-4">
                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">What is a parking protection plan?</h2>
                            <p>The parking protection plan is designed to assist with the cost of specific damages and theft incidents that may occur while your vehicle is parked.</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">What do I do if my car is damaged?</h2>
                            <p>If your vehicle is damaged, please visit <a href="https://www.parkguardclaims.com/spotsyncclaims" target="_blank" rel="noopener noreferrer">https://www.parkguardclaims.com/spotsyncclaims</a> to start the claims process.</p>
                            <p>In the case of theft, it's essential to contact the police and file a report as soon as possible. A police report is required in cases of theft.</p>
                            <p>All claims must be submitted within 72 hours after leaving the parking facility.</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">Is the parking protection plan mandatory?</h2>
                            <p>No, the parking protection plan is optional. You can choose to opt in or opt out of the plan when completing your parking purchase. If you decide not to include the plan, please be aware that you will be parking at your own risk.</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">What type of damage is covered?</h2>
                            <p>The parking protection plan covers physical damages resulting from accidents or theft, including:</p>
                            <ul>
                                <li>Door dings</li>
                                <li>Fender benders</li>
                                <li>Stolen items inside or outside the vehicle</li>
                            </ul>
                            <p>For a full list of what is included and excluded, and terms, please visit <a href="https://www.parkguard.com/terms-of-use-spotsync" target="_blank" rel="noopener noreferrer">https://www.parkguard.com/terms-of-use-spotsync</a></p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">How Much is Parking Protection?</h2>
                            <p>The fee may vary based on location and length of parking. The price is shown at checkout when booking your space.</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">What Kinds of protection Plans are offered?</h2>
                            <p>We may offer varying levels of protection plans based on locations, length of reservation, and type of parking. The most common plans are $1,000, $500, and $250 in protection. The protection plan limits will be shown to you at checkout.</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">Is the Protection Plan offered at all locations?</h2>
                            <p>No, the protection plan may not be offered at all locations on our website. If the location does not have the option to opt-in to the protection plan, then it is not offered at that location.</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">What is the benefit of having protection?</h2>
                            <p>You will avoid out of pocket expenses for damages like theft, door dings, and scratches that would normally be out of pocket expenses or require an expensive insurance deductible.</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs="12">
                    <Card className="h-100">
                        <Card.Body>
                            <h2 className="h4 mb-3">Is your parking dangerous?</h2>
                            <p>No! We offer these plans to be proactive because we realize that things happen. Most of our lots have staff, security cameras, and gates that keep them secure. This is added protection for even more peace of mind.</p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}